import type { FC } from 'react'
import { useMemo } from 'react'
import { cn } from '@/utils'
import { differenceInSeconds } from 'date-fns'
import { GroupRange } from './group-range.tsx'
import type { GroupTiming } from '../hooks/use-group-timing'

type CuesGroupPlannedTimeRangeProps = {
  groupTiming: GroupTiming | null
  timezone?: string | null
  className?: string
}

export const CuesGroupPlannedTimeRange: FC<CuesGroupPlannedTimeRangeProps> = ({
  groupTiming,
  timezone,
  className,
}) => {
  const isActualNotAsPlanned = useMemo(() => {
    if (!groupTiming) return false

    const startDifference = Math.abs(
      differenceInSeconds(groupTiming.original.start, groupTiming.actual.start),
    )
    const endDifference = Math.abs(
      differenceInSeconds(groupTiming.original.end, groupTiming.actual.end),
    )

    return startDifference > 1 || endDifference > 1
  }, [groupTiming])

  if (!groupTiming) return null

  return (
    <GroupRange
      start={groupTiming.original.start}
      end={groupTiming.original.end}
      timezone={timezone}
      className={cn(
        'opacity-50',
        isActualNotAsPlanned && 'line-through',
        className,
      )}
    />
  )
}
